// Import helpers
import { renderFormFields } from './renderFormFields';

// Import styles
import { Wrapper, FieldWrapper } from './styles';

// Import types
import { FormFieldsType } from 'types/views/form';

type Props = {
	fields: FormFieldsType;
};

export const FormFieldsRenderer = ({ fields }: Props) => (
	<Wrapper>
		{fields
			.filter((field) => !field.hidden)
			.map((field) => (
				<FieldWrapper key={field.label} gridConfig={field?.gridConfig} customStyles={field?.customStyles}>
					{renderFormFields(field)}
				</FieldWrapper>
			))}
	</Wrapper>
);
